import React from 'react'

const BoxManagementTableComponentLoadable = React.lazy(() => import('./BoxManagementTableComponent'))

export {
	BoxManagementTableComponentLoadable
}